import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2759_16752)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M12.4375 13.75C13.3004 13.75 14 13.0504 14 12.1875C14 11.3246 13.3004 10.625 12.4375 10.625C11.5746 10.625 10.875 11.3246 10.875 12.1875C10.875 13.0504 11.5746 13.75 12.4375 13.75Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M12.4375 6.625C13.3004 6.625 14 5.92544 14 5.0625C14 4.19956 13.3004 3.5 12.4375 3.5C11.5746 3.5 10.875 4.19956 10.875 5.0625C10.875 5.92544 11.5746 6.625 12.4375 6.625Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M12.4375 20.875C13.3004 20.875 14 20.1754 14 19.3125C14 18.4496 13.3004 17.75 12.4375 17.75C11.5746 17.75 10.875 18.4496 10.875 19.3125C10.875 20.1754 11.5746 20.875 12.4375 20.875Z" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2759_16752",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgAction;
